import React from 'react'
import type { EquityFormData } from 'submission/lib/equity-form-defaults'

type Props = {
  form: EquityFormData
  setForm: React.Dispatch<React.SetStateAction<EquityFormData>>
  errors: Record<string, string>
}

const NftSection: React.FC<Props> = ({ form, setForm, errors }) => {
  return (
    <section className="bg-white border border-slate-200 rounded p-6">
      <h2 className="text-lg font-semibold text-slate-900 mb-4">
        NFT metadata
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <label className="flex flex-col text-sm">
          <span className="text-slate-700 mb-1">NFT name *</span>
          <input
            className="border rounded px-2 py-1 text-slate-900 bg-white"
            value={form.nftName}
            onChange={(e) =>
              setForm((p) => ({ ...p, nftName: e.target.value }))
            }
          />
          {errors.nftName && (
            <span className="text-red-600 text-xs mt-1">{errors.nftName}</span>
          )}
        </label>
        <label className="flex flex-col text-sm">
          <span className="text-slate-700 mb-1">NFT symbol *</span>
          <input
            className="border rounded px-2 py-1 text-slate-900 bg-white"
            value={form.nftSymbol}
            onChange={(e) =>
              setForm((p) => ({ ...p, nftSymbol: e.target.value }))
            }
          />
          {errors.nftSymbol && (
            <span className="text-red-600 text-xs mt-1">
              {errors.nftSymbol}
            </span>
          )}
        </label>
      </div>
      <p className="text-xs text-slate-500 mt-2">
        TGE timestamp and non-transferable-until are derived from the timeline.
      </p>
    </section>
  )
}

export default NftSection
